export default __webpack_public_path__ + "static/media/student.9cbe8646.svg";